import React from "react";

const Skeleton = () => {
  return (
    <div className="flex flex-col">
      {/* Header Row Skeleton */}
      <div className="flex items-center justify-between gap-[10px]">
        <div className="flex items-center gap-2">
          {/* Count */}
          <div className="h-9 w-14 animate-pulse rounded bg-gray-200" />
          {/* Title */}
          <div className="h-6 w-52 animate-pulse rounded bg-gray-200" />
        </div>
        {/* Dropdown pill */}
        <div className="h-9 w-24 animate-pulse rounded-full bg-gray-200" />
      </div>

      {/* Change indicator */}
      <div className="mt-[6px] flex items-center gap-2">
        <div className="h-4 w-4 animate-pulse rounded bg-gray-200" />
        <div className="h-5 w-36 animate-pulse rounded bg-gray-200" />
      </div>

      {/* Divider */}
      <div className="mt-4 h-px w-full bg-gray-200" />

      {/* Section title */}
      <div className="mb-5 mt-5 h-5 w-80 animate-pulse rounded bg-gray-200" />

      {/* Content grid mirrors layout: keywords list + chart */}
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-8">
        {/* Keywords list column */}
        <div className="w-full min-w-0 md:max-w-[356px]">
          <div className="flex flex-col gap-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                <div className="h-5 w-16 animate-pulse rounded bg-gray-200" />
              </div>
            ))}
          </div>
        </div>

        {/* Chart column */}
        <div className="w-full min-w-0 rounded-xl border border-gray-200 md:max-w-[434px] md:flex-1">
          <div className="h-[242px] w-full animate-pulse rounded-xl bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
